import { getCollectionImageUrl } from "@/lib/cloudinary";

// Types d'événements
export type Event = {
  id: number;
  title: string;
  description: string;
  image: string;
  startDate: string; // Format YYYY-MM-DD
  endDate: string; // Format YYYY-MM-DD
  salons: string[];
  promoCode?: string;
  navigateTo?: string;
  isInfinite?: boolean; // Pour les événements sans date de fin affichée
};

// Liste des salons disponibles
const SALONS = ["Ville d'Avray", "Villejuif", "Au grey des couleurs", "Instant Grey Head Spa"];

// Liste statique des événements
export const events: Event[] = [
  {
    id: 1,
    title: "Découvrez le Head Spa",
    description:
      "Profitez de 15€ de réduction sur votre première séance Head Spa. Une expérience unique de relaxation et de soin du cuir chevelu.",
    image: getCollectionImageUrl("event", "soiree-massage-detente-voyage-sonore"),
    startDate: "2025-11-12",
    endDate: "2099-12-31",
    salons: ["Instant Grey Head Spa"],
    promoCode: "HEADSPA15",
    isInfinite: true,
  },
  {
    id: 2,
    title: "Et si octobre devenait le mois de la transformation ?",
    description:
      "À Ville‑d'Avray : -50 % sur la couleur. À Villejuif : -50 % sur la couleur et sur le balayage. Offres valables jusqu'au 31 octobre.",
    image: getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-08"),
    startDate: "2025-10-01",
    endDate: "2025-10-31",
    salons: ["Ville d'Avray", "Villejuif"],
  },
  {
    id: 3,
    title: "Novembre : Le mois des lissages et soins réparateurs",
    description:
      "Tous les salons : -30 % sur le lissage brésilien, soins Botox, lissage disciplinant et soin réparateur. Offre valable tout le mois de novembre.",
    image: getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-05"),
    startDate: "2025-11-01",
    endDate: "2025-11-30",
    salons: ["Ville d'Avray", "Villejuif", "Au grey des couleurs"],
  },
];

// Fonction pour formater la période d'un événement
export function formatEventPeriod(startDate: string, endDate: string, isInfinite?: boolean): string {
  // Si l'événement est infini, retourner une chaîne vide
  if (isInfinite) {
    return "";
  }

  const debut = new Date(startDate);
  const fin = new Date(endDate);

  const formatDate = (date: Date) => {
    const day = date.getDate();
    const month = date.toLocaleString("fr-FR", { month: "long" });
    return `${day} ${month}`;
  };

  return `${formatDate(debut)} - ${formatDate(fin)}`;
}

// Fonction pour obtenir les événements actuels
export function getCurrentEvents(): Event[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events.filter((event) => {
    // Vérification que la date est valide avant de comparer
    const endDate = new Date(event.endDate);
    if (isNaN(endDate.getTime())) {
      console.warn(
        `Date invalide pour l'événement "${event.title}": ${event.endDate}`,
      );
      return false;
    }

    endDate.setHours(23, 59, 59, 999);
    return endDate >= today;
  });
}
